import React from 'react'
import styled from 'styled-components'

import Dropdown, { Title, Input } from '@/components/sidebar/dropdown'
import { giphyLightBlue } from '@/styles/colors'

import { Article } from '../types'

const Container = styled.div`
  width: 900px;

  padding-bottom: 50px;
  margin-bottom: 50px;

  border-bottom: solid 1px #d0d0d0;

  ul {
    list-style: none;
    padding-left: 0px;
    font-size: 15px;
  }

  li {
    margin-bottom: 6px;
  }

  ${Input} ~ label > ${Title} {
    padding-left: 15px;
    border: none;

    font-size: 22px;
    text-decoration: none;
    color: black;

    font-weight: 900;
    font-family: 'Interface';

    ${Input}:checked ~ label > a {
      margin-bottom: 0;
      color: black;
      font-weight: 900;
    }

    &:hover {
      color: ${giphyLightBlue};
    }
  }
`

const Answer = styled.div`
  margin-top: 50px;

  > p {
    margin-bottom: 8px;
  }

  ol,
  ul {
    margin-left: 48px;

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    & > & {
      margin-bottom: 8px;
    }
  }

  ol {
    list-style: decimal;
  }

  ul {
    list-style: disc;
  }

  .wysiwyg-underline {
    display: inline-block;
    margin-top: 5px;
    font-size: 1.1rem;
  }

  img {
    display: inline-block;
    vertical-align: text-top;
  }
`

type Props = {
  article: Article
}

const Question = ({ article }: Props) => {
  const { body, title } = article

  return (
    <Container>
      <Dropdown title={title} isOpen={false} isActive={false}>
        <Answer dangerouslySetInnerHTML={{ __html: body }} />
      </Dropdown>
    </Container>
  )
}

export default Question
